import Vue from "vue";
import i18n from "./i18n";
import App from "./App.vue";
import "./main.scss";
import initPiwik from "./tracker";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faChevronRight);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

initPiwik(
  "9894a0b3-5d58-404c-90b5-0e462744bd17",
  "https://bisgraf.containers.piwik.pro"
);

new Vue({
  i18n,
  render: h => h(App)
}).$mount("#app");
